<template>
  <div v-if="showClubPoints" class="club-area-holder">
    <div class="heading-primary">{{ $t('my_account.navi.the_club') }}</div>
    <div class="club-holder">
      <div class="image">
        <Lips />
      </div>
      <div class="description">
        <div>{{ $t('my_account.the_club.beauty_points_member_info') }}</div>
        <div class="highlight">{{ $t('my_account.the_club.beauty_points_count_formatted', { count: cart?.club_points }) }}</div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { computed } from 'vue'
import Lips from "@/assets/images/lips.svg"
import { useUser } from '@/app/Checkout/composables/useUser'
import { useCart } from "@/app/Checkout/composables/useCart"

const { cart } = useCart()
const { user } = useUser()

const showClubPoints = computed(() => user.value?.club_member && cart.value?.club_points)
</script>
